import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import en from './en.json';
import ro from './ro.json';

export const resources = {
  en: {
    common: en,
  },
  ro: {
    common: ro,
  },
};

// Runs before the first render so every screen, including the last-resort error
// page shown when a provider crashes, has translations. The resources are
// bundled, so with initImmediate off the init completes synchronously.
export function initI18n(): void {
  if (i18n.isInitialized) return;

  i18n
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      defaultNS: 'common',
      resources,
      initImmediate: false,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    })
    .catch((error: unknown) => console.error('Could not init i18n', error));
}
